import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { IncomeForm } from 'pages/Profile/pages/ProfileOverview/components/PersonalInfo/Income/IncomeForm';
import ConfirmIncome from './assets/art-confirmIncome.svg';

const SelfReportedIncomeView = props => {
  const {
    annualIncomeInput,
    onChangeIncome,
    onClickSubmit,
    isSubmitDisabled,
    seenPixel,
  } = props;
  return (
    <>
      {seenPixel}
      <SectionContainer id="SelfReportedIncome">
        <div className="tabletHide">
          <Row>
            <FlexContainer className="justify-between align-items-center">
              <FlexContainer className="align-items-center">
                <img src={ConfirmIncome} alt="Confirm income" width={190} />
                <div className="margLR32">
                  <Label type="H3" typeHeader={'h3'}>
                    Is your income correct?
                  </Label>
                  <div className="SubTitle">
                    We use your income to make sure you get the best offers.
                  </div>
                </div>
              </FlexContainer>
              <div className="format33">
                <IncomeForm
                  incomeInput={annualIncomeInput.annualIncome}
                  onChangeIncome={onChangeIncome}
                  placeholder="Individual annual income"
                  outerClassName="fullWidth"
                />
                <Button
                  mrphType="primary"
                  className="margT16"
                  onClick={onClickSubmit}
                  disabled={isSubmitDisabled}
                  fullWidth
                >
                  Submit
                </Button>
              </div>
            </FlexContainer>
          </Row>
          <Row>
            <div className="caption margT24">
              Your personal income - before taxes. This can include wages,
              retirement, investments, benefits, rental properties, etc. Only
              list alimony, child support, or separate maintenance if you would
              like it considered on future applications for credit.
            </div>
          </Row>
        </div>
        <div className="desktopHide">
          <Row>
            <div className="format100 text-center">
              <img src={ConfirmIncome} alt="Confirm income" />
            </div>
            <Label
              type="H3"
              typeHeader={'h3'}
              className="text-24 margT16 margB8"
            >
              Is your income correct?
            </Label>
            <div className="SubTitle">
              We use your income to make sure you get the best offers.
            </div>
            <div className="margT24">
              <IncomeForm
                incomeInput={annualIncomeInput.annualIncome}
                onChangeIncome={onChangeIncome}
                placeholder="Individual annual income"
                outerClassName="fullWidth"
              />
              <Button
                mrphType="primary"
                className="margTB16"
                onClick={onClickSubmit}
                disabled={isSubmitDisabled}
                fullWidth
              >
                Submit
              </Button>
              <div className="caption">
                Your personal income - before taxes. This can include wages,
                retirement, investments, benefits, rental properties, etc. Only
                list alimony, child support, or separate maintenance if you
                would like it considered on future applications for credit.
              </div>
            </div>
          </Row>
        </div>
      </SectionContainer>
    </>
  );
};

export default SelfReportedIncomeView;
